module.exports = __webpack_public_path__ + "media/images/arrow-right-eba14a1954e6d307ca8150863092dab9.svg";